// Shared row primitive for grouped per-kind attribute cards (firearm,
// ammo, optics, holster). `required` rows must carry a value; if the
// value is empty, the row renders in iOS-red to make the invariant
// violation obvious. Optional empty rows render a neutral "Tap to add"
// placeholder — inline editing lands in PR B.

export type AttrRowSpec = {
  label: string;
  value: string | null;
  mono?: boolean;
  required?: boolean;
};

export function AttrRow({ row, last }: { row: AttrRowSpec; last: boolean }) {
  const isEmpty = row.value === null || row.value === "";
  const placeholderTone = row.required ? "text-[#ff3b30]" : "text-slate-400";
  const valueTone = isEmpty ? `${placeholderTone} italic` : "text-slate-900";
  const monoClass = row.mono && !isEmpty ? "font-mono tabular-nums tracking-tight" : "";
  return (
    <div
      className={`flex items-center gap-4 px-4 min-h-[52px] py-3 ${
        last ? "" : "border-b border-slate-200/80"
      }`}
    >
      <span className="text-[19px] text-slate-500 shrink-0">{row.label}</span>
      <span className={`ml-auto text-[19px] text-right min-w-0 ${valueTone} ${monoClass}`}>
        {isEmpty ? "Tap to add" : row.value}
      </span>
    </div>
  );
}
